import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  FormGroup,
  Container,
  FormInput,
  Row,
  Col,
  FormFeedback,
} from "shards-react";
import { useFormik } from "formik";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import { Loading } from "views/Indicators/components";
import contactimg from "shared/assets/img/contact.jpeg";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import Layout from "shared/container/Layout";

const axios = require("axios").default;
const ActiveUserContent = styled.div`
  padding: 30px 70px;
  color: #fff;
  border-radius: 6px;
  background-image: url(${contactimg});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  height: calc(100vh - 60px);
`;
const ActiveUser = (props) => {
  const { match } = props;
  const { t, i18n } = useTranslation();
  const [token, setToken] = useState(match.params.token);
  const [userId, setUserId] = useState(match.params.userId);
  console.log("token", token);
  console.log("userId", userId);
  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          userId: userId,
        },
        update: {
          userStatus: 2,
        },
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/user/update`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          showNotify(t("common:resetPassword.UserConfirmationSuccessful"));
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        })
        .catch((error) => {
          showNotify(error.message, "error");
        });
    }
  }, []);

  return (
    <Layout>
    <ActiveUserContent>
      <Container>
        <Row>
          <Col sm={{ size: 6, order: 3, offset: 3 }}>
            <h5 className="bold text-center color-white">
              {t("common:logIn.VerifyIdentity")}
            </h5>
            {/* <h6 className="bold color-white">เปลี่ยนรหัสผ่านใหม่</h6> */}
          </Col>
        </Row>
        <Row>
          <Col sm={{ size: 6, order: 3, offset: 3 }}>
            <Button
              className="btn btn-white w-100 mb-3"
              onClick={() => (window.location.href = "/")}
            >
              {t("common:resetPassword.Home")}
            </Button>
          </Col>
        </Row>
      </Container>
    </ActiveUserContent>
    </Layout>
  );
};

export default ActiveUser;
